import React from 'react'
import Member from './Member'
import {teamData} from '../CustomData/teamData'
const Team = () => {
    // Infuture we can fetch this data from API
    return (
        <div className="row g-4">
            {teamData.map((member, index) => (
                <Member
                    name={member.name}
                    position={member.position}
                    image={member.image}
                />
            ))}
        </div>
    )
}

export default Team
